<template>
    <div class="calendar-input / flex" :class="{...screenSizeClasses}" @click.stop>
        <MaltDatePicker
            key="from"
            v-model="fromDate"
            :label="$t('projectclient.projectlist.topbar.filters.date.field.from')"
            name="from"
            :max-date="toDate"
        />
    </div>
    <div class="calendar-input / flex" :class="{...screenSizeClasses}" @click.stop>
        <MaltDatePicker
            key="to"
            v-model="toDate"
            :label="t('projectclient.projectlist.topbar.filters.date.field.to')"
            name="to"
            :min-date="fromDate"
        />
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useScreenSizeStore} from '@common/stores';
    import {storeToRefs} from 'pinia';
    import {MaltDatePicker} from '#components';
    import {useTranslation} from '#imports';

    const {t} = useTranslation();

    const props = defineProps<{from?: Date; to?: Date}>();

    const emit = defineEmits<{
        'update:from': [value: Date | undefined];
        'update:to': [value: Date | undefined];
        update: [];
    }>();

    const screenSizeStore = useScreenSizeStore();
    const {screenSizeClasses} = storeToRefs(screenSizeStore);

    const fromDate = computed({
        get: () => (props.from ? new Date(props.from) : undefined),
        set(value) {
            emit('update:from', value);
            emit('update');
        },
    });

    const toDate = computed({
        get: () => (props.to ? new Date(props.to) : undefined),
        set(value) {
            emit('update:to', value);
            emit('update');
        },
    });
</script>

<style lang="scss" scoped>
    @use '../filters-common.scss' as *;

    .calendar-input {
        flex-flow: column wrap;

        $root: &;

        &_label {
            font-weight: var(--joy-font-weight-bold);
            font-size: var(--joy-font-size-primary-300);
            margin-bottom: var(--joy-core-spacing-2);
        }

        &.isMobileScreen {
            margin-bottom: var(--joy-core-spacing-5);
        }

        &.isProjectListTabletScreen {
            margin-right: var(--joy-core-spacing-6);
        }

        &.isSmallScreen {
            #{$root}_label {
                margin-bottom: 0;
                font-weight: var(--joy-font-weight-normal);
            }
        }

        &.isProjectListDesktopScreen {
            width: 100%;
        }
    }
</style>
